import moment from "moment";

export const computedOnlineStatusText = (update, sleep) => {
  const sleepTime = sleep + 60;
  const timeNow = moment().unix();
  const lastUpdate = Number(update) + Number(sleepTime);

  if (lastUpdate >= timeNow) {
    return "Online";
  } else {
    return "Offline";
  }
};

export const computedOnlineStatusColor = (update, sleep) => {
  const sleepTime = sleep + 60;
  const timeNow = moment().unix();
  const lastUpdate = Number(update) + Number(sleepTime);

  if (lastUpdate >= timeNow) {
    return "success";
  } else {
    return "danger";
  }
};
